import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CityProvider }          from "./context/CityContext";
import { AuthProvider }          from "./context/AuthContext";
import { AdminAuthProvider }     from "./context/AdminAuthContext";
import { InspectorAuthProvider } from "./context/InspectorAuthContext";
import { SellRequestProvider }   from "./context/SellRequestContext";
import { ShortlistProvider }     from "./context/ShortlistContext";
import { DriverAuthProvider }    from "./context/DriverAuthContext";
 
import Navbar      from "./components/Navbar";
import Footer      from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ChatBot     from "./components/ChatBot";
import ReferAndEarnPage from './components/referral/ReferAndEarn';
import DealerPayments from "./pages/dealer/DealerPayments";
 
// ── Auth ──
import PhoneLogin     from "./components/PhoneLogin";
import Signup         from "./components/Signup";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword  from "./components/ResetPassword";
 
// ── Pages ──
import Home                  from "./pages/Home";
import CarList                from "./pages/CarList";
import BuyCars                from "./pages/BuyCars";
import Profile                from "./pages/Profile";
import BrandPage              from "./pages/BrandPage";
import ModelPage              from "./pages/ModelPage";
import CarDetailPage          from "./pages/CarDetailPage";
import AboutUs                from "./pages/AboutUs";
import FinanceCar             from "./pages/FinanceCar";
import Services               from "./pages/Services";
import Shortlisted            from "./pages/Shortlisted";
import Valuation              from "./pages/Valuation";
import ScrapCar               from "./pages/ScrapCar";
import Blogs                  from "./pages/Blogs";
import HowItWorks             from "./pages/HowItWorks";
import CarHubLocations        from "./pages/CarHubLocations";
import EChallan               from "./pages/EChallan";
import Reviews                from "./pages/Reviews";
import ServiceCostCalculator  from "./pages/ServiceCostCalculator";
import TermsAndConditions     from "./pages/TermsAndConditions";
import PrivacyPolicy          from "./pages/PrivacyPolicy";
 
// ── Review Form (token-based, no login needed) ── ✅ NEW
import ReviewFormPage from "./pages/ReviewFormPage";
 
// ── Sell Car ──
import SellCarLanding  from "./components/SellCar/SellCarLanding";
import SellCarCity     from "./components/SellCar/SellCarCity";
import SellCarWizard   from "./components/SellCar/SellCarWizard";
import MySells         from "./pages/MySells";
 
// ── Payments ──
import PaymentPage    from "./pages/PaymentPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentHistory from "./components/payments/PaymentHistory";
 
// ── Admin ──
import AdminLogin      from "./pages/admin/AdminLogin";
import AdminDashboard  from "./pages/admin/AdminDashboard";
import AdminRouteGuard from "./components/admin/AdminRouteGuard";
 
// ── Inspector ──
import InspectorLogin            from "./pages/inspector/InspectorLogin";
import InspectorDashboard        from "./pages/inspector/InspectorDashboard";
import InspectorInspections      from "./pages/inspector/InspectorInspections";
import InspectorInspectionDetail from "./pages/inspector/InspectorInspectionDetail";
import InspectorSchedule         from "./pages/inspector/InspectorSchedule";
import InspectorRouteGuard       from "./components/inspector/InspectorRouteGuard";
 
// ── Driver ──
import DriverLogin      from "./pages/driver/DriverLogin";
import DriverDashboard  from "./pages/driver/DriverDashboard";
import DriverRouteGuard from "./components/driver/DriverRouteGuard";
 
// ── Dealer ──
import { DealerAuthProvider }  from "./context/DealerAuthContext";
import DealerLogin             from "./pages/dealer/DealerLogin";
import DealerLayout            from "./pages/dealer/DealerLayout";
import DealerDashboard         from "./pages/dealer/DealerDashboard";
import DealerListings          from "./pages/dealer/DealerListings";
import DealerListingDetail     from "./pages/dealer/DealerListingDetail";
import DealerMyOffers          from "./pages/dealer/DealerMyOffers";
import DealerProfile           from "./pages/dealer/DealerProfile";
import DealerSellCar           from "./pages/dealer/DealerSellCar";
import DealerMyCarListings     from "./pages/dealer/DealerMyCarListings";
import DealerRouteGuard        from "./components/dealer/DealerRouteGuard";
 
import "./styles/App.css";
 
export default function App() {
  return (
    <AuthProvider>
      <AdminAuthProvider>
        <InspectorAuthProvider>
          <DriverAuthProvider>
            <DealerAuthProvider>
              <CityProvider>
                <SellRequestProvider>
                  <ShortlistProvider>
                    <Router>
                      <ScrollToTop />
                      <Routes>
 
                        {/* ── Admin (no Navbar/Footer) ── */}
                        <Route path="/admin/login"     element={<AdminLogin />} />
                        <Route path="/admin/dashboard" element={<AdminRouteGuard><AdminDashboard /></AdminRouteGuard>} />
 
                        {/* ── Inspector (no Navbar/Footer) ── */}
                        <Route path="/inspector/login"           element={<InspectorLogin />} />
                        <Route path="/inspector/dashboard"       element={<InspectorRouteGuard><InspectorDashboard /></InspectorRouteGuard>} />
                        <Route path="/inspector/inspections"     element={<InspectorRouteGuard><InspectorInspections /></InspectorRouteGuard>} />
                        <Route path="/inspector/inspections/:id" element={<InspectorRouteGuard><InspectorInspectionDetail /></InspectorRouteGuard>} />
                        <Route path="/inspector/schedule"        element={<InspectorRouteGuard><InspectorSchedule /></InspectorRouteGuard>} />
 
                        {/* ── Driver (no Navbar/Footer) ── */}
                        <Route path="/driver/login"     element={<DriverLogin />} />
                        <Route path="/driver/dashboard" element={<DriverRouteGuard><DriverDashboard /></DriverRouteGuard>} />
 
                        {/* ── Dealer (no Navbar/Footer) ── */}
                        <Route path="/dealer/login" element={<DealerLogin />} />
                        <Route
                          path="/dealer"
                          element={<DealerRouteGuard><DealerLayout /></DealerRouteGuard>}
                        >
                          <Route path="dashboard"       element={<DealerDashboard />} />
                          <Route path="listings"        element={<DealerListings />} />
                          <Route path="listings/:id"    element={<DealerListingDetail />} />
                          <Route path="my-offers"       element={<DealerMyOffers />} />
                          <Route path="profile"         element={<DealerProfile />} />
                          <Route path="sell-car"        element={<DealerSellCar />} />
                          <Route path="my-car-listings" element={<DealerMyCarListings />} />
                          <Route path="payments"        element={<DealerPayments />} />
                        </Route>
 
                        {/* ── Review Form (WhatsApp token link, no login, no Navbar) ── ✅ NEW */}
                        <Route path="/review/:token" element={<ReviewFormPage />} />
 
                        {/* ── Regular user routes (Navbar + Footer) ── */}
                        <Route path="/*" element={
                          <div className="App">
                            <Navbar />
                            <div className="main-content">
                              <Routes>
                                <Route path="/"       element={<Home />} />
 
                                <Route path="/login"           element={<PhoneLogin />} />
                                <Route path="/phone-login"     element={<PhoneLogin />} />
                                <Route path="/signup"          element={<Signup />} />
                                <Route path="/forgot-password" element={<ForgotPassword />} />
                                <Route path="/reset-password"  element={<ResetPassword />} />
 
                                <Route path="/cars"                element={<CarList />} />
                                <Route path="/buy-cars"            element={<BuyCars />} />
                                <Route path="/brand/:brand"        element={<BrandPage />} />
                                <Route path="/brand/:brand/:model" element={<ModelPage />} />
                                <Route path="/buy-cars/:city/:brand/:model/:variantYear/:id" element={<CarDetailPage />} />
                                <Route path="/car/:id"             element={<CarDetailPage />} />
 
                                <Route path="/sell-car"               element={<SellCarLanding />} />
                                <Route path="/sell-car/:city"         element={<SellCarCity />} />
                                <Route path="/sell-car/:city/journey" element={<SellCarWizard />} />
                                <Route path="/my-sells"               element={<MySells />} />
 
                                <Route path="/how-it-works"            element={<HowItWorks />} />
                                <Route path="/about"                   element={<AboutUs />} />
                                <Route path="/finance"                 element={<FinanceCar />} />
                                <Route path="/services"                element={<Services />} />
                                <Route path="/services/:location"      element={<Services />} />
                                <Route path="/scrap-car"               element={<ScrapCar />} />
                                <Route path="/valuation"               element={<Valuation />} />
                                <Route path="/shortlisted"             element={<Shortlisted />} />
                                <Route path="/locations"               element={<CarHubLocations />} />
                                <Route path="/echallan"                element={<EChallan />} />
                                <Route path="/blog"                    element={<Blogs />} />
                                <Route path="/profile"                 element={<Profile />} />
                                <Route path="/reviews"                 element={<Reviews />} />
                                <Route path="/service-cost-calculator" element={<ServiceCostCalculator />} />
 
                                <Route path="/payment"          element={<PaymentPage />} />
                                <Route path="/payment-success"  element={<PaymentSuccess />} />
                                <Route path="/payments/history" element={<PaymentHistory />} />
 
                                <Route path="/terms"      element={<TermsAndConditions />} />
                                <Route path="/privacy"    element={<PrivacyPolicy />} />
                                <Route path="/refer-earn" element={<ReferAndEarnPage />} />
                              </Routes>
                            </div>
                            <ChatBot />
                            <Footer />
                          </div>
                        } />
 
                      </Routes>
                    </Router>
                  </ShortlistProvider>
                </SellRequestProvider>
              </CityProvider>
            </DealerAuthProvider>
          </DriverAuthProvider>
        </InspectorAuthProvider>
      </AdminAuthProvider>
    </AuthProvider>
  );
}